import type { Teammate } from "../types/teammates";
import { isToday } from "./formatDate";

export function teammateChatPath(
  teammate: Pick<Teammate, "id" | "last_conversation_id" | "last_chat_at">,
): string {
  return teammate.last_conversation_id && isToday(teammate.last_chat_at)
    ? `/chat?c=${teammate.last_conversation_id}`
    : `/chat?teammate=${teammate.id}`;
}
